
<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useRouter,useRoute } from 'vue-router';
import axiosInstance from '@/plugins/axios';

const router = useRouter();
const route = useRoute();
const progress = ref({});
const langId = ref(route.params.translation as string);

// get translation progress
const getTranslationProgress = async () => {
    try {
        const response = await axiosInstance.get(`/translations/${langId.value}`);
        return response.data.progress;
    } catch (error) {
        console.error('Error fetching translation progress:', error);
        return null;
    }
};

const goTo = (category) => {
    router.push({ path: `/tenant/translations/${route.params.translation}/${category}` });
};


const hasMissingInCategory = (prefix: string) => {
    return Object.keys(progress.value?.missingFields || {}).some(key => key.startsWith(prefix));
};

const hasMissingQuestionsOrOptions = computed(() =>
    Object.keys(progress.value?.missingFields || {}).some(key =>
        key.startsWith('questions.') || key.startsWith('options.')
    )
);

const hasMissingEvaluation = computed(() =>
    Object.keys(progress.value?.missingFields || {}).some(key =>
        key.startsWith('evaluations.')
    )
);

const hasMissingFaq = computed(() =>
    Object.keys(progress.value?.missingFields || {}).some(key =>
        key.startsWith('faqs.') || key.startsWith('faqCategories.')
    )
);

const hasMissingStaticTexts = computed(() =>
    Object.keys(progress.value?.missingFields || {}).some(key =>
        key.startsWith('staticTexts')
    )
);


onMounted(async () => {
    progress.value = await getTranslationProgress();
    if (progress) {
        console.log('Translation progress:', progress);
    }
});
</script>

<template>
    <div>
        <Tag class="card cardError p-2 text-black">
            Unfinished translations
        </Tag>
        <div class="card-grid">
            <Card class="menuCard"   :class="{ 'cardError': hasMissingQuestionsOrOptions }"  @click="goTo('questions_options')">
                <template #title>
                    Questions & Options
                </template>
                <template #subtitle>
                    Questions and options displayed in the questionnaire
                </template>
                <template #content>
                    <font-awesome-icon :icon="['fa-solid', 'question']" size="2x" />
                </template>
            </Card>

            <Card class="menuCard" :class="{ 'cardError': hasMissingEvaluation }" @click="goTo('evaluation')">
                <template #title>
                    Evaluation
                </template>
                <template #subtitle>
                    Texts displayed on the results page
                </template>
                <template #content>
                    <font-awesome-icon :icon="['fa-solid', 'list']" size="2x" />
                </template>
            </Card>
            <Card class="menuCard" :class="{ 'cardError': hasMissingFaq }" @click="goTo('faq')">
                <template #title>
                    FAQ
                </template>
                <template #subtitle>
                    Frequently Asked Questions, including answers and categories
                </template> 
                <template #content>
                    <font-awesome-icon :icon="['fa-solid', 'person-circle-question']" size="2x"  class="mb-auto" />
                </template>
            </Card>
            <Card class="menuCard" :class="{ 'cardError': hasMissingStaticTexts }" @click="goTo('staticTexts')">
                <template #title>
                    Static Texts
                </template>
                <template #subtitle>
                    Static texts such as the disclaimer or the imprint.
                </template>
                <template #content>
                    <font-awesome-icon :icon="['fa-solid', 'fa-globe']" size="2x" class="mb-auto" />
                </template>
            </Card>
        </div>
    </div>
</template>


<style scoped>
.cardError {
  border: 2px solid #f44336;
  background-color: #ffebee;
}
</style>